if($(window).width() <= 768){
  var swiper = new Swiper('.icon-with-text-slider', {
    slidesPerView: 1,
    spaceBetween:0,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    centeredSlides: true,
    autoplay: {
      delay: 50000,
      disableOnInteraction: false,
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
    const headings = document.querySelectorAll('.footer h2.footer-block__heading');

    headings.forEach(function (heading) {
        heading.addEventListener('click', function () {
            this.classList.toggle('active');
        });
    });
});
///pdp/
$('.close-btn').click(function() {
      $('.key_features').hide();
  });
///pdp/
///// Tab Faq
$(document).on('click','.acctab_title', function(e){
   if($(window).width() >= 768){
      $('.acctab_title').removeClass('active-accor');
      $(this).addClass('active-accor');
      $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
      $($(this).attr('data-act-title')).addClass('activemain-tab').show();
   }else{
     $('.acctab_title').removeClass('active-accor');
      $(this).addClass('active-accor');
      $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
      $($(this).attr('data-act-title')).addClass('activemain-tab').show();
      // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
      $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
      $($(this).attr('data-act-title')).addClass('activemain-tab').show();
   }
});
$(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
    $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
});
$('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
});
///// Tab Faq
// custom price

class PriceRange1 extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

    // Event listeners for text input focus and change
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

    this.textInputLowerBound.addEventListener("change", (event) => {
      const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      event.target.value = newValue;
      this.rangeLowerBound.value = newValue;
      this.updateRangeStyles();
    });

    this.textInputHigherBound.addEventListener("change", (event) => {
      const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      event.target.value = newValue;
      this.rangeHigherBound.value = newValue;
      this.updateRangeStyles();
    });

    // Event listeners for range slider change and input
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeLowerBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      this.textInputLowerBound.value = event.target.value;
      this.updateRangeStyles();
    });

    this.rangeHigherBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      this.textInputHigherBound.value = event.target.value;
      this.updateRangeStyles();
    });
  }

  updateRangeStyles() {
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
  }
}

window.customElements.define("price-range1", PriceRange1);

// custom price



/****** theme custom menu appears on hover Start ******/
     // Add this code make menu appears on hover
          function bindMouseOverToMegaMenu (item) {
            item.addEventListener("mouseover", () => {
                item.setAttribute("open", true);
                item.querySelector(".mega-menu__content, .header__submenu").addEventListener("mouseover", () => {
                  item.setAttribute("open", true);
                });
                item.querySelector(".mega-menu__content, .header__submenu").addEventListener("mouseleave", () => {
                  item.removeAttribute("open");
                });
              item.addEventListener("mouseleave", () => {
                item.removeAttribute("open");
              });
            });
          }
     let main_header_iner_items = document.querySelector(".header__inline-menu");
    if(main_header_iner_items){
    let items = main_header_iner_items.querySelectorAll("details.mega_menu_hover, details.drop-down-hover");
    items.forEach(bindMouseOverToMegaMenu);
    }
/****** theme custom menu appears on hover End ******/

